import {undef} from './undef';

const NONE_FIELD_AUTO_PROGRESS_TYPE = 'none';
const STANDARD_FIELD_AUTO_PROGRESS_TYPE = 'standard';
const SMART_FIELD_AUTO_PROGRESS_TYPE = 'smart';

const DEFAULT_FIELD_AUTO_PROGRESS_TYPE = STANDARD_FIELD_AUTO_PROGRESS_TYPE;

const FIELD_AUTO_PROGRESS_TYPES = [
    NONE_FIELD_AUTO_PROGRESS_TYPE,
    STANDARD_FIELD_AUTO_PROGRESS_TYPE,
    SMART_FIELD_AUTO_PROGRESS_TYPE
];

// eslint-disable-next-line complexity
function allowFieldAutoProgress(formOptions, fieldOptions, config = {}) {
    const {
        autoProgress: formAutoProgress
    } = formOptions;

    const {
        autoProgress: fieldAutoProgress
    } = fieldOptions;

    const {
        isNextFieldValuesNotFilled
    } = config;

    return (
        fieldAutoProgress === undef && formAutoProgress === 'standard' ||
        fieldAutoProgress === undef && formAutoProgress === 'smart' && isNextFieldValuesNotFilled ||
        fieldAutoProgress === 'standard' ||
        fieldAutoProgress === 'smart' && isNextFieldValuesNotFilled
    );
}

function allowFieldAutoSubmit(formOptions, fieldOptions) {
    const {
        autoSubmit: formAutoSubmit
    } = formOptions;

    const {
        autoSubmit: fieldAutoSubmit
    } = fieldOptions;

    return (
        fieldAutoSubmit ||
        formAutoSubmit && fieldAutoSubmit === undef
    );
}

function allowInputFieldErrorHighlighting(formOptions, fieldOptions) {
    const {
        allowErrorHighlighting: allowFormErrorHighlighting
    } = formOptions;

    const {
        allowErrorHighlighting: allowFieldErrorHighlighting
    } = fieldOptions;

    return (
        allowFieldErrorHighlighting ||
        allowFormErrorHighlighting && allowFieldErrorHighlighting === undef
    );
}

export {
    NONE_FIELD_AUTO_PROGRESS_TYPE,
    STANDARD_FIELD_AUTO_PROGRESS_TYPE,
    SMART_FIELD_AUTO_PROGRESS_TYPE,
    DEFAULT_FIELD_AUTO_PROGRESS_TYPE,
    FIELD_AUTO_PROGRESS_TYPES,
    allowFieldAutoProgress,
    allowFieldAutoSubmit,
    allowInputFieldErrorHighlighting
};
